import CalendarHome from '@/views/Calendar/CalendarHome'

export default [
  {
    path: '/calendar/home',
    name: 'calendar-home',
    component: CalendarHome
  }
]
